import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useLazyGetParamsQuery } from "../redux/paramService";
import {
  useGetTokenMutation,
  usePostPaymentMoraleMutation,
  usePostPaymentMutation,
} from "../redux/paymentService";
const UsagerPayments = () => {
  const [
    getParams,
    { data, isLoading: paramIsLoading, isError: paramIsError },
  ] = useLazyGetParamsQuery();
  const [getToken] = useGetTokenMutation();
  const [postPayment] = usePostPaymentMoraleMutation();
  const [postPaymentData] = usePostPaymentMutation();

  const [frais, setFrais] = useState();
  const params = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  console.log("params", queryParams);
  console.log("location", location);
  const myParam = queryParams.get("data");
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const paymentData = JSON.parse(myParam);

  console.log(
    "Vous allez être redirigé vers la page de paiement, veuillez patienter quelques secondes",
    myParam,
    myParam
  );
  const handlePayment = async () => {
    setIsLoading(true);
    await getToken()
      .unwrap()
      .then(async (res) => {
        console.log("Orange Web Payment Token", res);

        localStorage.setItem("om_token", res.access_token);

        await handlePaymentData(res.access_token);
      })
      .catch((err) => {
        console.log("Erreur", err);
      });
    setIsLoading(false);
  };

  const handlePaymentData = async (token) => {
    console.log("launching payment ....");

    console.log("my pay data", paymentData);
    console.log("token", token);
    if (token) {
      postPayment({ paymentData, token })
        .unwrap()
        .then((res) => {
          console.log("Orange Web Payment", res);
          window.location.href = res.payment_url;
        })
        .catch((err) => {
          console.log("Erreur", err);
          setIsError(true);
        });
    }
  };

  useEffect(() => {
    const fetchParams = async () => {
      try {
        const response = await getParams({ endpoint: "systemes" }).unwrap();
        const found = response?.data?.find(
          (item) => item.attributes.name === "frais"
        );
        if (found) {
          setFrais(found.attributes);
          console.log("frais", found.attributes);
        } else {
          console.log("Aucun frais trouvé");
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des paramètres:", error);
      }
    };

    fetchParams();
  }, [getParams]);

  useEffect(() => {
    handlePayment();
  }, [frais]);
  return <div></div>;
};

export default UsagerPayments;
